export default __webpack_public_path__ + "static/media/youtube-black.e936bf40.svg";